module.exports = __webpack_public_path__ + "static/media/christhoval_barba_es.13c7aaa7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/cv/christhoval_barba_es.pdf
// module id = 167
// module chunks = 0